import { type MagentoFlavorAttribute } from "@jti/magento-types";

export type MultipleFlavorsSelectorItem = {
  id: string | number;
  name?: string | null;
  description?: string;
  image: {
    url?: string;
  };
  attributes?: MagentoFlavorAttribute[];
  brandOptionId?: string;
};
